import React from 'react';
import NewPickForm from './NewPickForm';
import { FormStep, Pick } from 'src/models';
import NoMatchupsCard from 'src/components/Picks/NoMatchupsCard';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type NewPicksPanelProps = {
  picks: Pick[];
  steps: FormStep[];
};
export const NewPicksPanel = ({ picks, steps }: NewPicksPanelProps) => {
  return (
    <>
      {steps.length > 0 ? (
        <Stack direction='column' spacing={1}>
          {steps.map((step, index) => (
            <Accordion key={index} disableGutters>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls='panel1-content'
                id='panel1-header'
              >
                {`${step.homeTeam.teamName} vs ${step.awayTeam.teamName}`}
              </AccordionSummary>
              <AccordionDetails>
                <NewPickForm
                  picks={picks}
                  gamePk={step.gamePk}
                  playoffRound={step.playoffRound}
                  playoffSeriesLetter={step.playoffSeriesLetter}
                  season={step.season}
                  homeTeam={step.homeTeam.teamName}
                  awayTeam={step.awayTeam.teamName}
                  homePlayers={step.homePlayers}
                  awayPlayers={step.awayPlayers}
                  teams={[
                    {
                      id: step.homeTeam.id,
                      name: step.homeTeam.name,
                      abbreviation: step.homeTeam.abbreviation,
                      homeTeam: true,
                    },
                    {
                      id: step.awayTeam.id,
                      name: step.awayTeam.name,
                      abbreviation: step.awayTeam.abbreviation,
                      homeTeam: false,
                    },
                  ]}
                  startTime={step.startTime}
                  numOfSteps={steps.length}
                />
              </AccordionDetails>
            </Accordion>
          ))}
        </Stack>
      ) : (
        <NoMatchupsCard />
      )}
    </>
  );
};
